import { z } from 'zod';
import { avatarUrlSchema, nameSchema, stringifiedDateSchema } from '@/utils/schemas';

export const friendScheme = z.object({
  ID: z.number(),
  UserID: z.number(),
  ChatSessionID: z.number(),
  FriendID: z.number(),
  FriendNickName: nameSchema,
  FriendHeadImg: avatarUrlSchema,
  FriendSign: nameSchema,
  RemarkName: nameSchema,
  IsOnline: z.number().pipe(z.coerce.boolean()),
  OnlineDesc: z.string().nullish(),
  Hide: z.number().pipe(z.coerce.boolean()),
  Shield: z.number().pipe(z.coerce.boolean()),
  Status: z.number().pipe(z.coerce.boolean()),
  CreateTime: stringifiedDateSchema,
  SortChar: z.string(),
  VChatID: z.string(),
  Order: z.number().optional().default(-1),
});

export type Friend = z.infer<typeof friendScheme>;
